import CSS from "./styles.module.css";
import Button from "../Button/Button";
import { useState } from "react";
import { useEffect } from "react";

const PromotionsFlyout = ({ element }) => {
	const [isActive, setIsActive] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setIsActive(true);
		}, 5000);
	}, []);

	return (
		<>
			<div className={CSS.PromoFlyoutContainer}>
				<div
					className={`${CSS.PromoFlyout} ${
						isActive ? CSS.PromoFlyoutActive : ""
					}`}
				>
					<Button
						variant="SmallButton"
						className={CSS.CloseButton}
						leftIcon="close"
						onClick={() => setIsActive(false)}
					></Button>
					{element}
				</div>
			</div>
			<Button
				variant="SmallButton"
				className={`${CSS.ExpandButton} ${
					isActive ? CSS.ExpandButtonHide : ""
				}`}
				leftIcon="keyboard_arrow_up"
				onClick={() => setIsActive(true)}
			></Button>
		</>
	);
};

export default PromotionsFlyout;
